module.exports = __webpack_public_path__ + "static/media/slide_2.3015d731.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dashboard/slide_2.png
// module id = 1145
// module chunks = 0